import React from "react";

const VideoCall = () => {
  return <div>fdgfd</div>;
};

export default VideoCall;
